import { TextField } from '@rikstv/shared-components';
import { FC } from 'react';

import classes from './AddressSearchInput.module.css';

type Props = {
  id: string;
  defaultValue?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
};

export const AddressSearchInput: FC<Props> = ({ id, defaultValue, onChange, disabled }) => (
  <div className={classes.container}>
    <TextField
      id={id}
      disabled={disabled}
      className={classes.input}
      data-testid="address-search-input"
      aria-controls="search-results"
      defaultValue={defaultValue}
      name="adr-search"
      label={disabled && defaultValue ? '' : 'Søk på din addresse'}
      autoComplete="street-address"
      onChange={onChange}
    />
    <span className={classes.mapIconContainer}>
      <MapIcon />
    </span>
  </div>
);

const MapIcon = () => (
  <svg width="13" height="19" viewBox="0 0 13 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Map Marker Icon</title>
    <path
      d="M11.4375 6.40234C11.4375 3.6064 9.17094 1.33984 6.375 1.33984C3.57906 1.33984 1.3125 3.6064 1.3125 6.40234C1.3125 6.93209 1.51698 7.73038 1.89111 8.7124C2.25875 9.67736 2.76657 10.7612 3.32153 11.8391C4.29269 13.7253 5.39284 15.5634 6.09814 16.665L6.375 17.0898L6.65186 16.665C7.35716 15.5634 8.45731 13.7253 9.42847 11.8391C9.98343 10.7612 10.4913 9.67736 10.8589 8.7124C11.233 7.73038 11.4375 6.93209 11.4375 6.40234ZM8.625 6.40234C8.625 5.1597 7.61764 4.15234 6.375 4.15234C5.13236 4.15234 4.125 5.1597 4.125 6.40234C4.125 7.64498 5.13236 8.65234 6.375 8.65234C7.61764 8.65234 8.625 7.64498 8.625 6.40234ZM9.75 6.40234C9.75 8.2663 8.23896 9.77734 6.375 9.77734C4.51104 9.77734 3 8.2663 3 6.40234C3 4.53838 4.51104 3.02734 6.375 3.02734C8.23896 3.02734 9.75 4.53838 9.75 6.40234ZM12.5625 6.40234C12.5625 7.15022 12.2915 8.1114 11.9099 9.11304C11.5218 10.1317 10.9934 11.2562 10.4282 12.354C9.2978 14.5495 7.9983 16.6786 7.3125 17.7124L7.31177 17.7117C7.10333 18.0258 6.75203 18.2148 6.375 18.2148C5.99793 18.2148 5.64594 18.0259 5.4375 17.7117V17.7124C4.7517 16.6786 3.4522 14.5495 2.32178 12.354C1.75656 11.2562 1.22819 10.1317 0.840088 9.11304C0.458481 8.1114 0.1875 7.15022 0.1875 6.40234C0.1875 2.98508 2.95774 0.214844 6.375 0.214844C9.79226 0.214844 12.5625 2.98508 12.5625 6.40234Z"
      fill="#313131"
    />
  </svg>
);
